import { Button } from "@root/shared/components/Button";
import { Icon } from "@root/shared/components/Icon";
import { type ComponentPropsWithRef, type FC, forwardRef } from "react";
import * as styles from "./styles.css";

type Props = Omit<ComponentPropsWithRef<"button">, "children"> & {
  shopLength: number;
};

export const ShowShopWorksButton: FC<Props> = forwardRef((props, ref) => {
  const { shopLength } = props;
  // propsからbuttonコンポーネントに不要なものを削除する
  const buttonProps: Omit<ComponentPropsWithRef<"button">, "children"> = Object.fromEntries(
    Object.entries(props).filter(
      ([key]) => !(key === "shopLength" || key === "showShopWorksButtonRef"),
    ),
  );
  return (
    <Button
      {...buttonProps}
      theme="tertiary"
      size="small"
      rightIcon={<Icon name="arrow-bold-right" fontSize="16px" />}
      className={styles.button}
      ref={ref}
    >
      <span>
        他<span className={styles.shopLength}>{shopLength}</span>店舗の求人を見る
      </span>
    </Button>
  );
});
ShowShopWorksButton.displayName = "ShowShopWorksButton";
